import { CheckBox, TextField } from '@nv/basic-components'
import { SearchAddress, SearchAddressNV } from '@nv/components'
import { useConfigurationContext } from '@nv/contexts'
import { nxConfig } from '@nv/utils'
import { useTranslation } from 'react-i18next'

export const AddressInput = ({
  formik,
  styles,
  addressFieldName = 'address',
  searchAddressFieldName = 'searchAddress',
  addressNotListedFieldName = 'addressNotListed',
  autocomplete = null,
  adminEditAddressList = false,
}: any) => {
  const { t } = useTranslation()
  const { enableManualEntryAddress } = useConfigurationContext()
  return (
    <>
      {!formik.values[addressNotListedFieldName] &&
        (nxConfig.useNVAddress || adminEditAddressList ? (
          <div className={styles['form__address']}>
            <SearchAddressNV objFieldName={searchAddressFieldName} formik={formik} />
            <TextField
              formik={formik}
              type='text'
              field={`${searchAddressFieldName}.unitNumberPOBox`}
              placeholder={t('form.labels.unitNumberAndPO')}
              label={t('form.labels.unitNumberAndPO')}
              isRequired={false}
              autocomplete={autocomplete}
            />
          </div>
        ) : (
          <div className={styles['form__address']}>
            <SearchAddress objFieldName={searchAddressFieldName} formik={formik} />
            <TextField
              formik={formik}
              type='text'
              field={`${searchAddressFieldName}.unitNumberPOBox`}
              placeholder={t('form.labels.unitNumber')}
              label={t('form.labels.unitNumberAndPO')}
              isRequired={false}
              autocomplete={autocomplete}
            />
          </div>
        ))}
      {formik.values[addressNotListedFieldName] && (
        <div className={styles['form__address']}>
          <TextField
            formik={formik}
            type='text'
            field={`${addressFieldName}.streetAddress`}
            placeholder={t('form.labels.streetAddress')}
            label={t('form.labels.streetAddress')}
            autocomplete={autocomplete}
          />
          <TextField
            formik={formik}
            type='text'
            field={`${addressFieldName}.unitNumberPOBox`}
            placeholder={t('form.labels.unitNumberAndPO')}
            label={t('form.labels.unitNumberAndPO')}
            isRequired={false}
            autocomplete={autocomplete}
          />
          <TextField
            formik={formik}
            type='text'
            field={`${addressFieldName}.city`}
            placeholder={t('form.labels.city')}
            label={t('form.labels.city')}
            autocomplete={autocomplete}
          />
          <TextField
            formik={formik}
            type='text'
            field={`${addressFieldName}.province`}
            placeholder={t('form.labels.province')}
            label={t('form.labels.province')}
            autocomplete={autocomplete}
          />
          <TextField
            formik={formik}
            type='text'
            field={`${addressFieldName}.postalCode`}
            placeholder={t('form.labels.postalCode')}
            label={t('form.labels.postalCode')}
            autocomplete={autocomplete}
          />
        </div>
      )}
      {enableManualEntryAddress ? (
        <CheckBox
          formik={formik}
          field={addressNotListedFieldName}
          checked={formik.values[addressNotListedFieldName]}
          onChange={() => formik.setFieldValue(addressNotListedFieldName, !formik.values[addressNotListedFieldName])}
          label={t('registration.addressNotListed')}
          ariaLabel={t('registration.addressNotListed')}
          square={true}
        />
      ) : (
        <span style={{ fontStyle: 'italic' }}>{t('registration.form.errors.missingAddress')}</span>
      )}
    </>
  )
}
